import { css } from '@bts-web/utils-style-engine';
import { Divider } from '../../common/components/Divider/Divider';

const dividerStyles = css({
  marginInlineStart: '-24px',
  width: 'calc(100% + 48px)',
  borderBottomColor: 'var(--colors-neutrals-divider)',
  borderBottomWidth: '1px',
});

export const TargetAssetDivider = () => {
  return <Divider className={dividerStyles} />;
};
